<template>
  <div class="modal">
    <div class="main-form">
      <p class="title">{{$t('title')}}</p>
      <el-form
        label-position="right"
        label-width="90px"
        class="form"
        ref="form"
        :rules="rules"
        size="mini"
        :model="form"
      >
        <el-form-item :label="$t('password') + ':'" prop="newPwd">
          <el-input v-model="form.newPwd" type="password" :placeholder="$ct('messages.password')"></el-input>
        </el-form-item>
        <br>
        <el-form-item class="confirm-item" :label="$t('confirmPassword') + ':'" prop="pwd">
          <el-input v-model="form.pwd" type="password" :placeholder="$ct('messages.password')"></el-input>
        </el-form-item>
        <el-button
          type="primary"
          size="mini"
          style="margin-top:20px;padding:10px 40px;border-radius:20px"
          @click="confirm"
        >{{$ct('confirm')}}</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { sameAs } from '@/utils/validators'
export default {
  data() {
    return {
      form: {
        newPwd: '',
        pwd: ''
      }
    }
  },
  computed: {
    rules() {
      return {
        newPwd: [
          { required: true, message: this.$ct('messages.required'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$ct('messages.minMax', [6, 20]), trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: this.$ct('messages.required'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$ct('messages.minMax', [6, 20]), trigger: 'blur' },
          { validator: sameAs('form.newPwd'), message: this.$ct('messages.passwordSame'), vm: this, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async confirm() {
      await this.$refs.form.validate()
      const res = await API.patch(`/edu/zone/student/password`, {
        password: this.form.pwd
      })
      if (res.status < 400) {
        this.$message({
          type: 'success',
          message: this.$ct('csuccess')
        })
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lang-en {
  .confirm-item /deep/ .el-form-item__label {
    line-height: 1.2;
  }
}
.title {
  font-size: 12px;
  text-align: center;
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 8887;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-form {
  width: 425px;
  background: white;
  height: 300px;
  border-radius: 6px;
  padding: 50px;
}
.form {
  margin-top: 30px;
  text-align: center;
}
</style>
<i18n lang="yaml">
en:
  title: For your account security, please change your password
  password: Password
  confirmPassword: Confrim password
zh-CN:
  title: 为了您的账号安全，请修改您的密码
  password: 新密码
  confirmPassword: 确认密码
zh-TW:
  title: 為了您的賬號安全，請修改您的密碼
  password: 新密碼
  confirmPassword: 確認密碼
it:
  title: Per la sicurezza del tuo account, cambia la password
  password: Password
  confirmPassword: Conferma password
id:
  title: Demi keamanan akun Anda, Silahkan ubah kata sandi Anda
  password: Kata sandi
  confirmPassword: Konfirmasi kata sandi
</i18n>
